/* eslint-disable
  import/extensions,
  max-lines-per-function,
  @typescript-eslint/no-explicit-any
*/
import { ReactElement } from 'react';
import BarHighChart from '@components/_elements/BarHighChart/BarHighChart';
import FormattedAlias from '@components/_shared/Translations/FormattedAlias';
import useAlias from '@alias';
import storeConnector from '@store/storeConnector';
import { TimeMode } from '@types';

interface EnergyProductionProps {
  battActive: boolean;
  dailyChartData: any;
  formatDailyData: any;
  loadingChartsData: any;
  pvActive: boolean;
  windActive: boolean;
  timeMode: TimeMode;
}

function EnergyProduction({
  battActive,
  dailyChartData,
  formatDailyData,
  loadingChartsData,
  pvActive,
  windActive,
  timeMode,
}: EnergyProductionProps): ReactElement {
  const alias = useAlias();

  return (
    <div className='in' style={{ display: 'flex', flexDirection: 'column' }}>
      <div className='title-line mb-2 ml-1'>
        <FormattedAlias id='Energy Production' /> MWh
      </div>
      <div className='eng-prod-legend'>
        {pvActive && (
          <div className='pv label'>
            <FormattedAlias id='PV Production' />
          </div>
        )}
        {windActive && (
          <div className='wind label'>
            <FormattedAlias id='Wind Production' />
          </div>
        )}
        {battActive && (
          <div className='bess label'>
            <FormattedAlias id='BESS Energy' />
          </div>
        )}
      </div>
      {(dailyChartData !== undefined && dailyChartData.length > 0) ||
      loadingChartsData.daily !== undefined ? (
        <BarHighChart
          unit={alias('MWh')}
          margins={{ top: 55, right: 30, bottom: 35, left: 60 }}
          variables={{
            ...(pvActive ? { [alias('PV Production')]: 'PV' } : {}),
            ...(windActive ? { [alias('Wind Production')]: 'Wind' } : {}),
            ...(battActive ? { [alias('BESS energy')]: 'BESS' } : {}),
          }}
          barsClasses={[
            ...(pvActive ? [0] : []),
            ...(windActive ? [1] : []),
            ...(battActive ? [2] : []),
          ]}
          loading={loadingChartsData.daily}
          data={formatDailyData}
          timeMode={timeMode}
          useUTC={true} // Use UTC because the data backend returns UTC timestamps
        />
      ) : (
        <div className='placeholder-no-data'>
          <FormattedAlias id='No data available for Energy Production chart' />
        </div>
      )}
    </div>
  );
}

export default storeConnector(EnergyProduction, {
  service: ['timeMode'],
});
